import { getToken } from "services/Auth";
import ProfileService from "services/profile/ProfileService";

const isPrivacyEnabled = (teamConfig) => {
  if (teamConfig?.privacyEnabled === undefined || teamConfig?.privacyEnabled === null) {
    return true;
  }
  return Number(teamConfig.privacyEnabled) === 1;
};

export const resolveTermsOfUseVisibility = (teamConfig) => {
  const token = getToken();
  if (!token) {
    return false;
  }

  const profile = ProfileService.parseJWT(token);
  const termsOfUse = Number(profile.userPrivacy);

  if (!isPrivacyEnabled(teamConfig) || termsOfUse !== 0) {
    return false;
  }

  const acceptedPrivacyRaw = localStorage.getItem("ACCEPTY_PRIVACY");
  const acceptedPrivacy = acceptedPrivacyRaw === null ? null : Number(acceptedPrivacyRaw);

  if (acceptedPrivacy === null) {
    localStorage.setItem("ACCEPTY_PRIVACY", termsOfUse);
    return true;
  }

  if (acceptedPrivacy === 1) {
    return false;
  }

  return true;
};
